import { getAddBooksData } from '../services/getAddBooksData';

export const addBooksData = (data, queryFetched, institutionCode) => {
  const dataToAdd = getAddBooksData(institutionCode);

  if (dataToAdd.length > 0) {
    let dataAdded = data;
    const queryLower = queryFetched.toLowerCase();

    dataToAdd.forEach((element) => {
      const hasMatch = element.words?.some(
        (word) => word.toLowerCase() === queryLower
      );

      if (hasMatch) {
        dataAdded = [element, ...dataAdded];
      }
    });

    return dataAdded;
  }

  return data;
};